// `PlorbinPic` is a component
// containing the tunnel img element
const PlorbinPic = () => {
return <div id="plorbin-pic"></div>
}

export default PlorbinPic